import React, { forwardRef, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
//stores
import useAdminStore from "src/webapp/stores/admin.store";
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//hook
import useAccountHook from 'src/webapp/hooks/account/account.hook';
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//styles
import styles from 'src/asset/scss/styles/userMemberInfo.module.scss';
//compWrapper
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//comp
import EmptyData from 'src/webapp/views/component/data/EmptyData';
import PaymentCancelPopup from '../popup/PaymentCancel';//결제취소팝업

const VehicleList = forwardRef((props, pageRef) => {
    const params = useParams();//queryParameter
    const { list } = props;
    //hook
    const { isOpen, dataRef, onDismissHandler } = useAccountHook();
    const { axiosPostHandler } = useAxiosHook();//axios
    //store
    const { admin } = useAdminStore();//stores
    //hooks
    const { setOnMessageHandler
        , stateFilter//예약상태필터
        , categoryFilter//카테고리필터
    } = useComnHook();
    //리스트토글엘리먼트show&hide
    const [ toggle,setToggle ] = useState({});
    /* ============================ 예약취소API ============================ */
    const isLock = useRef(false);
    const reservCancelAPI = async(item) => {//CANCEL_CODE: 7 (미입고 취소)
        if(isLock.current || !window.confirm("예약을 취소한 후에는 다시 복구할 수 없습니다.\n취소하시겠습니까?")) { return; }

        isLock.current = true;
        const DATA = { MEMBER_CD:params.cd, PARTNER_CD:item.PARTNER_CD , ORDER_NO:item.ORDER_NO, CANCEL_CODE:7, CANCEL_CONTENT:"고객요청에 의한 취소" };
        const result = await axiosPostHandler(`memberReservCancelForAdmin.do`, DATA);
        setTimeout(() => { isLock.current = false; }, 300)
        if (result.message !== "SUCCESS") { setOnMessageHandler(2, "취소 할 수 없는 예약 입니다.\n잠시후 다시 시도해주시기 바랍니다."); }
        if (result.message === "SUCCESS") {
            memberReservListHandler();
            setOnMessageHandler(1, "예약취소가 성공적으로 처리되었습니다.")
        }
    }
    //상위컴포넌트 예약내역호출핸들러
    const memberReservListHandler = () => {
        pageRef.current = 20;
        props.memberReservListAPI(0, 1);
    }
    /* ============================ 예약취소API ============================ */
    return (
        <> 
        {list?.length > 0 ?
        <Element tag={`ul`}>
            {list.length > 0 ? list.map((item, i) =>
                <Element tag={`li`} key={item.ORDER_NO}>
                    <Element tag={`div`} className={styles.vehicleInfo}>
                        <Element tag={`div`} >
                            <Element tag={`div`} style={{width: "8.125rem"}}><Element tag={`label`}>{item.PARTNER_NAME}</Element></Element><hr/>
                            <Element tag={`div`} style={{width: "11.94rem"}} className={styles.center}><Element tag={`span`}>방문일 {item.RESERV_DT}</Element></Element><hr/>
                            <Element tag={`div`} style={{width: "10.25rem"}} className={styles.center}><Element tag={`label`}>{item.BRAND_KOR_NAME + " " + item.MODEL_KOR_NAME}</Element></Element><hr/>
                            <Element tag={`div`} style={{width: "4.25rem"}} className={styles.center}><Element tag={`label`}>{item.YEAR}년식</Element></Element><hr/>
                            <Element tag={`div`} className={[styles.stretch, ("state" + item.STATE)].join(" ")}><Element tag={`label`}>{stateFilter(item.STATE)}</Element></Element>
                            <a onClick={(e) => setToggle(toggle === item ? {} : item)}><FontAwesomeIcon icon={["fa-light", toggle === item ? "fa-chevron-up": "fa-chevron-down"].join(" ")} /></a>
                        </Element>
                    </Element>
                    {toggle === item ? 
                    <Element tag={`article`}>
                        <Element tag={`div`} className={styles.toggleContent}>
                            <Element tag={`div`} style={{width: "8.625rem"}}><Element tag={`span`}><FontAwesomeIcon icon="fa-light fa-scribble" />주행거리<Element tag={`strong`}>{item.KMLE}</Element>km</Element></Element><hr/>
                            <Element tag={`div`}>
                                <Element tag={`label`}>카테고리</Element>
                                {item.ITEM_LIST.length > 0 ? 
                                    <Element tag={`div`}>
                                    {item.ITEM_LIST.length > 0 ? item.ITEM_LIST.map((children, i) =>
                                        <React.Fragment key={i}>
                                        {children.CATEGORY === (i > 0 ? item.ITEM_LIST[i - 1].CATEGORY : null) || i === 0 ? <span>[{categoryFilter(children.CATEGORY)}]</span> : null}
                                        <Element tag={`pre`}>{children.ITEM_NAME}</Element>
                                        </React.Fragment>
                                    ):null}
                                    </Element>
                                : null}
                            </Element><hr/>
                            <Element tag={`div`} >
                                <Element tag={`label`}>전달사항</Element>
                                {item.CONTENT !== undefined ? <Element tag={`div`}><Element tag={`pre`}>{item.CONTENT}</Element></Element> : null}
                            </Element><hr/>
                            <Element tag={`div`} >
                                <Element tag={`label`}>정비</Element>
                                {item.RESULT !== undefined ? <Element tag={`div`}><Element tag={`label`}>정비내용</Element><Element tag={`pre`}>{item.RESULT}</Element></Element> : null}
                                {item.REMARK !== undefined ? <Element tag={`div`}><Element tag={`label`}>특이사항</Element><Element tag={`pre`}>{item.REMARK}</Element></Element> : null}
                            </Element>
                        </Element>
                        <Element tag={`div`}  className={styles.toggleContainer}>
                            <Element tag={`ul`}>
                                <Element tag={`li`}>
                                    <Element tag={`div`} style={{width: "5.125rem"}}><Element tag={`span`}>{item.PAY_METHOD}</Element></Element><hr/>
                                    <Element tag={`div`} style={{width: "11.94rem"}}><Element tag={`span`}>예약일 {item.REG_DT}</Element></Element><hr/>
                                    <Element tag={`div`} style={{width: "7.25rem"}}><Element tag={`span`}><FontAwesomeIcon icon="fa-light fa-coins" />{item.AMOUNT}</Element></Element><hr/>
                                    <Element tag={`div`} className={styles.stretch}><Element tag={`span`}><FontAwesomeIcon icon="fa-light fa-coin" />{item.BALANCE_AMT}</Element></Element>
                                    <Element tag={`div`} className={styles.btnArea}>
                                        {admin.LEVEL <= 1 && item.STATE === "1" || item.STATE === "2" ? <Element anyprop={(e) => reservCancelAPI(item)} tag={`button`}><Element tag={`span`}>예약취소</Element></Element> : null }
                                        {admin.LEVEL <= 1 && item.STATE !== "6" && item.STATE !== "8" && item.CANCLE_YN === "Y" ? <Element anyprop={(e) => onDismissHandler('cancel', true, item)} tag={`button`}><Element tag={`span`}>결제취소</Element></Element> : null }
                                    </Element>
                                </Element>
                            </Element>
                        </Element>
                    </Element>
                    : null}
                </Element>
            ) : null}
        </Element>
        : <EmptyData/> }
        {isOpen.cancel ? <PaymentCancelPopup isOpen={isOpen.cancel} data={dataRef} onDismiss={onDismissHandler} /> : null}
        </>
    );
})

export default VehicleList;